import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
} from '@chakra-ui/react'
import { ItemLayout } from './ItemLayout'

export function ListLayout({ layouts }) {
  return (
    <TableContainer overflow="auto">
      <Table variant="simple" size="sm">
        <Thead>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Posição
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              SOLICITAÇÃO
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Tipo
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Nota
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Referência
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Vendedor
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Produto
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Cor
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Gravação
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Prazo
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              Obs
            </Text>
          </Th>
          <Th bg="gray.200">
            <Text as="span" fontSize="sm" fontWeight="bold">
              QTD Batidas
            </Text>
          </Th>
        </Thead>
        <Tbody>
          {layouts?.map((layout, index) => (
            <ItemLayout key={layout.id + layout.referencia} layout={layout} />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
